// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"410":"07c1857b","842":"903f0eea"}[chunkId] + ".chunk.js";
};